<script>
export default {
    name: "StockAdjustmentTypeForm"
}
</script>
<template>
    <div class="flex">
        <div class="md:w-1/4 sm:w-full p-tiny">
            <label class="label-control" for="name">Type:</label>
            <input type="text" class="input-control input-sm text-xs" id="name">
        </div>
        <div class="md:w-1/4 sm:w-full p-tiny">
            <label class="label-control" for="deducts">Deducts/Increases:</label>
            <tail-select>
                <template v-slot:field>
                    <select name="" id="deducts" class="input-control input-sm text-xs">
                        <option value="">Deducts</option>
                        <option value="">Increases</option>
                    </select>
                </template>
            </tail-select>
        </div>
        <div class="md:w-1/12 sm:w-1/2 p-tiny mt-4">
            <label for="active" class="label-control">Active
                <input type="checkbox" name="" id="active">
            </label>
        </div>
        <div class="md:w-1/12 sm:w-1/2 mt-4">
            <button class="btn-info btn-sm text-xs rounded"><i class="fa fa-save"></i> Save</button>
        </div>
    </div>
</template>
